import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Share2, Copy } from "lucide-react";
import { createBillSignLink } from "../../api/accounting";
import { useApiError } from "../../hooks/useApiError";
const writeClipboard = async (text) => {
  try { await navigator.clipboard.writeText(text); }
  catch {
    const ta = document.createElement("textarea");
    ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.focus(); ta.select();
    try { document.execCommand("copy"); } finally { document.body.removeChild(ta); }
  }
};

// زرّان بسيطان: مشاركة عبر قائمة النظام + نسخ. النصّ = الرابط فقط، لأن معاينة WhatsApp تعرض كل التفاصيل.
export const BillShareButton = ({ bill }) => {
  const { t, i18n } = useTranslation();
  const describe = useApiError();
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const ensure = async () => {
    if (url) return url;
    const lang = (i18n.language || "ar").startsWith("en") ? "en" : "ar";
    const r = await createBillSignLink(bill.id, lang);
    setUrl(r.url);
    return r.url;
  };
  const share = async () => {
    setBusy(true);
    try {
      const link = await ensure();
      if (navigator.share) {
        try { await navigator.share({ title: t("acct.bills.share.subject"), url: link }); }
        catch (err) { if (err.name !== "AbortError") throw err; }
      } else {
        await writeClipboard(link);
        toast.success(t("acct.bills.share.copied"));
      }
    } catch (err) { toast.error(describe(err)); } finally { setBusy(false); }
  };
  const copy = async () => {
    setBusy(true);
    try {
      const link = await ensure();
      await writeClipboard(link);
      toast.success(t("acct.bills.share.copied"));
    } catch (err) { toast.error(describe(err)); } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" onClick={share} disabled={busy} data-testid={`share-btn-${bill.id}`}
              className="flex items-center gap-2 rounded-2xl bg-sky-500 px-4 py-2 text-xs font-black text-white shadow-md hover:bg-sky-600 disabled:opacity-50">
        <Share2 className="h-4 w-4" /> {t("acct.bills.share.action")}
      </button>
      <button type="button" onClick={copy} disabled={busy} data-testid={`copy-btn-${bill.id}`}
              className="flex items-center gap-2 rounded-2xl border-2 border-sky-500/50 bg-sky-500/10 px-4 py-2 text-xs font-black text-sky-600 hover:bg-sky-500/20 disabled:opacity-50">
        <Copy className="h-4 w-4" /> {t("acct.bills.share.copy")}
      </button>
    </>
  );
};
